import { motion } from 'framer-motion';

export function TravelInfoSection() {
  const travelInfoLinks = [
    {
      icon: 'ri-restaurant-line',
      title: '맛집',
      description: '제주의 특색이 담긴 한 끼의 식사로 여행을 완성하세요',
      image: 'https://public.readdy.ai/ai/img_res/430af3509de5f9a7a824fe21dce6e815.jpg',
      link: 'https://www.visitjeju.net/kr/detail/list?menuId=DOM_000001719001000000&cate1cd=cate0000000005'
    },
    {
      icon: 'ri-map-2-line',
      title: '관광지도',
      description: '여행출발 전에 다운로드 하시거나, 우편으로 받아보세요',
      image: 'https://readdy.ai/api/search-image?query=Detailed%20Jeju%20island%20tourist%20map%20with%20colorful%20landmarks%20and%20attractions%20marked%2C%20comprehensive%20travel%20guide%20map%20with%20clear%20design%2C%20professional%20cartography%20with%20simple%20clean%20background&width=600&height=400&seq=info-map-001&orientation=landscape',
      link: 'https://www.visitjeju.net/kr/tourInfo/guide'
    },
    {
      icon: 'ri-walk-line',
      title: '올레길',
      description: '나만의 속도와 나만의 방법으로 제주를 여행한다',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20Jeju%20Olle%20trail%20walking%20path%20along%20dramatic%20coastline%20with%20green%20fields%2C%20serene%20hiking%20route%20through%20natural%20landscape%2C%20professional%20travel%20photography%20with%20soft%20natural%20colors%20and%20simple%20clean%20background&width=600&height=400&seq=info-olle-001&orientation=landscape',
      link: 'https://www.jejuolle.org/trail/kor/'
    },
    {
      icon: 'ri-mountain-line',
      title: '한라산등반',
      description: '철저한 계획으로 즐거운 등반여행 되시길 바랍니다',
      image: 'https://readdy.ai/api/search-image?query=Majestic%20Hallasan%20mountain%20peak%20with%20hiking%20trail%20and%20natural%20landscape%2C%20stunning%20volcanic%20mountain%20scenery%20of%20Jeju%2C%20professional%20nature%20photography%20with%20clear%20blue%20sky%20and%20vibrant%20colors&width=600&height=400&seq=info-halla-001&orientation=landscape',
      link: 'https://www.jeju.go.kr/hallasan/index.htm'
    }
  ];

  return (
    <section className="py-20 sm:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-3 bg-[#4A7C59]/10 px-6 py-3 rounded-full mb-6">
            <i className="ri-information-line text-[#4A7C59] text-xl"></i>
            <span className="text-[#4A7C59] text-lg font-medium">Travel Information</span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#2C2C2C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            출발 전 확인!!
          </h2>
          <p className="text-2xl sm:text-3xl font-bold text-[#FF8E53]">
            제주 여행 정보
          </p>
        </motion.div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {travelInfoLinks.map((info, index) => (
            <motion.a
              key={index}
              href={info.link}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <div className="w-full h-full">
                    <img 
                      src={info.image}
                      alt={info.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                      <i className={`${info.icon} text-2xl text-[#0E7FC0]`}></i>
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">
                    {info.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {info.description}
                  </p>
                  <div className="flex items-center gap-2 text-[#0E7FC0] font-medium group-hover:gap-3 transition-all">
                    <span>자세히 보기</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </motion.a>
          ))}
        </div>

        {/* Additional Links */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-8 sm:p-12"
        >
          <h3 className="text-2xl sm:text-3xl font-bold text-[#2C2C2C] mb-8 text-center">
            유용한 제주 여행 링크
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {[
              { name: '제주도청', link: 'https://www.jeju.go.kr/', icon: 'ri-government-line' },
              { name: '제주관광공사', link: 'https://www.visitjeju.net/', icon: 'ri-building-line' },
              { name: '제주올레', link: 'https://www.jejuolle.org/', icon: 'ri-footprint-line' },
              { name: '한라산국립공원', link: 'https://www.jeju.go.kr/hallasan/', icon: 'ri-mountain-line' },
              { name: '제주항공', link: 'https://www.jejuair.net/', icon: 'ri-plane-line' },
              { name: '제주날씨', link: 'https://www.weather.go.kr/', icon: 'ri-sun-cloudy-line' }
            ].map((link, index) => (
              <a
                key={index}
                href={link.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-3 bg-white rounded-xl p-4 hover:shadow-lg transition-all hover:-translate-y-1"
              >
                <div className="w-12 h-12 bg-[#0E7FC0]/10 rounded-full flex items-center justify-center">
                  <i className={`${link.icon} text-2xl text-[#0E7FC0]`}></i>
                </div>
                <span className="text-sm font-medium text-gray-700 text-center">
                  {link.name}
                </span>
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
